import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Answer, Replica} from "@/store/meet/types";
import EducationPanel from "@/scenes.ui/education-panel";
import {Keys} from "@/constants/key";
import TextButton from "@/scenes.ui/text-button";
import {CustomPlaceContainer} from "@/scenes.ui/custom-place-container";
import PlayerStore from "@/store/player";
import {Tr} from "@/i18n/i18n";
import RoadScene from "@/scenes/roadScene";
import {Point} from "@/model/point";
import {ArrowAnimData} from "@/services/education-service";
import CU from "@/utils/c-u";
import {ArrowMode} from "@/store/place/types";
import Blackout from "@/scenes.ui/blackout";

export class CustomPlaceDialog extends Container implements CustomPlaceContainer {

    public static DEPTH: number = 4000;

    private canvas!: HTMLCanvasElement;
    private educationPanel!: EducationPanel;
    private callback!: (answer: Answer) => unknown;
    private removeDialogIconCallback!:() => void
    private createDialogIconCallback!:() => void

    constructor(scene: Scene, canvas: HTMLCanvasElement, removeDialogIconCallback: ()=>void, createDialogIconCallback: ()=> void) {
        super(scene);
        this.canvas = canvas;
        this.removeDialogIconCallback = removeDialogIconCallback;
        this.createDialogIconCallback = createDialogIconCallback;
    }

    public init(replica: Replica, callback: (answer: Answer) => unknown): void {
        const self = this;
        this.callback = callback;
        this.createDialogIconCallback();
        this.educationPanel = new EducationPanel(this.scene, 0, undefined);
        this.educationPanel.disableClickPropagation();
        this.add(this.educationPanel);
        this.setDepth(CustomPlaceDialog.DEPTH);

        this.setup(replica);
    }

    setup(replica: Replica): void {

        if (replica.specialFrontCommand) {
            let self = this;
            switch (replica.specialFrontCommand) {
                case 'darken':
                    let blackoutedNow: boolean = Blackout.show(self.scene, self.canvas, 9999);
                    if (blackoutedNow) {
                        EducationPanel.TEXT_DELAY = 1500;
                        self.scene.time.delayedCall(3000, () => {
                            if (self.scene.scene.isActive()) {
                                self.alpha = 0;
                                self.depth = 10000;
                                self.doSetup(replica);
                                self.scene.tweens.add({
                                    targets: self,
                                    delay: 100,
                                    alpha: 1,
                                    duration: 700,
                                });
                            }
                        });
                    } else {
                        EducationPanel.TEXT_DELAY = 100;
                        self.doSetup(replica);
                    }
                    break;
            }
        } else {

            this.doSetup(replica);
        }
    }

    doSetup(replica: Replica): void {
        const self = this;
        let answer = replica.answers![0];
        let title = replica.title;

        let eduImage = replica.imageId ? replica.imageId : PlayerStore.getPlayer()!.companionImage;
        if (replica.imageId === '{cat}') {
            eduImage = PlayerStore.getPlayer()!.companionImage;
            title = Tr('catto');
        } else if (replica.imageId === '{hero}') {
            let isFemale = PlayerStore.getPlayer()!.companionImage.includes('female');
            eduImage = isFemale ? 'edu-woman1' : 'edu-man1';
            title = isFemale ? Tr('joanne') : Tr('johnny');
        } else if (replica.imageId === '{marko}') {
            let isFemale = PlayerStore.getPlayer()!.companionImage.includes('female');
            eduImage = isFemale ? 'marko' : 'mar';
            title = isFemale ? Tr('marko') : Tr('mar');
        } else if (replica.imageId == '{p6_hero_1}') {
            let isFemale = PlayerStore.getPlayer()!.companionImage.includes('female');
            eduImage = isFemale ? 'dark_alice' : 'dark_jonny';
            title = isFemale ? Tr('an.y.w') : Tr('an.y.m');
        } else if (replica.imageId == '{p6_hero_2}') {
            let isFemale = PlayerStore.getPlayer()!.companionImage.includes('female');
            eduImage = isFemale ? 'dark_alice_t' : 'dark_johnny_t';
            title = isFemale ? Tr('an.y.w') : Tr('an.y.m');
        }
        let okButton: any = undefined;
        this.educationPanel!.init(eduImage, replica.mainText!, () => {
            okButton = new TextButton(this.scene, 410, 210, Keys.GREEN_HORIZONTAL_BUTTON, answer.text!);

            if (answer.arrow) {
                let needArroyClue = true;
                let arrowAnimData: ArrowAnimData|null = null;
                let scene = this.scene as RoadScene;
                scene.time.delayedCall(3000, () => {
                    if (needArroyClue) {
                        arrowAnimData = scene.showArrow(new Point(okButton.x, okButton.y + (20 * CU.S)), ArrowMode.PERSISTENT, false, true);
                    }
                });
                okButton.buttonImage.once("pointerdown", () => {
                    needArroyClue = false;
                    if (arrowAnimData) {
                        for (let go of arrowAnimData.gameObjects) {
                            go.destroy();
                        }
                    }
                });
            }

            self.add(okButton);
            okButton.alpha = 0;

            this.scene.tweens.chain({
                targets: okButton,
                tweens: [
                    {},
                    {
                        duration: 400,
                        alpha: 1
                    }]
            });

            okButton.setCallback(() => {
                if (okButton) {
                    okButton.destroy();
                }
                self.callback(answer);
            });
        }, ()=>{
            // if (okButton) {
            //     okButton.destroy();
            // }
            // self.callback(answer);
        }, title);
    }

    openAnimated(): void {
        this.scene.add.existing(this);
    }

    close(): void {
        this.removeDialogIconCallback();
        this.setVisible(false);
        this.destroy();
    }

    public isSceneDefined() {
        return !!this.scene;
    }
}
